/* ── CONSENT-GATED TRACKING ─────────────────────────────────────
   GTM (GA4 / Google Ads) and CallRail's swap.js are loaded ONLY
   after the visitor accepts the consent banner — see
   src/components/consent.js for the loaders and the CIPA-risk
   rationale, and consent-banner.js for the UI. Ported from the
   GVD Renovations implementation (July 2026).

   For RETURNING visitors (consent cookie already set) trackers
   load on `onInitialClientRender` — i.e. AFTER React's first
   hydration — so the CallRail tracking-number DOM swap never
   races hydration. First-time visitors load trackers even later
   (on Accept click), which is safer still. */
exports.onInitialClientRender = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  const { getConsent, loadTrackers } = require('./src/components/consent')
  if (getConsent() === 'granted') {
    loadTrackers()
  }
}

/* SPA-style route change handler.

   1. First-party landing/attribution capture (localStorage) —
      NOT consent-gated: data a visitor's browser hands directly
      to us, never sent to a third party from here.

   2. Re-runs CallTrk.swap() on every Gatsby Link navigation
      (no-op until the visitor has consented and swap.js loaded).

   3. Pushes the `gatsby-route-change` dataLayer event that
      gatsby-plugin-google-tagmanager used to emit (plugin removed
      from gatsby-config.js), so GTM triggers built on that event
      keep firing pageviews on SPA navigations. The 50ms delay
      matches the plugin's behavior (lets the new page title
      settle before the tag reads it). No-op for visitors who
      haven't consented — dataLayer only matters once GTM loads. */
exports.onRouteUpdate = ({ location, prevLocation }) => {
  //if landing URL does not exist in local storage, set current pathname
  if (
    typeof window !== 'undefined' &&
    window.localStorage &&
    !window.localStorage.getItem('lNdUrL')
  ) {
    window.localStorage.setItem('lNdUrL', location.href)
    window.localStorage.setItem('lNdUrLDtIme', new Date())
  }

  window.localStorage.setItem('crNtPaTH', location.href)
  window.localStorage.setItem(
    'prevPaTHnAme',
    prevLocation ? prevLocation.href : null
  )

  if (window && window.CallTrk) {
    try {
      window.CallTrk.swap()
    } catch (e) {
      // silent — same posture as initial load
    }
  }

  if (window.dataLayer && typeof window.dataLayer.push === 'function') {
    setTimeout(() => {
      window.dataLayer.push({ event: 'gatsby-route-change' })
    }, 50)
  }
}

/* Mount the consent banner on every page. Must mirror the
   wrapPageElement in gatsby-ssr.js exactly (same tree shape) or
   React 18 hydration mismatches appear. The banner renders null
   until after mount, so it adds nothing to SSR output. */
exports.wrapPageElement = ({ element }) => {
  const React = require('react')
  const ConsentBanner = require('./src/components/consent-banner').default
  return React.createElement(
    React.Fragment,
    null,
    element,
    React.createElement(ConsentBanner)
  )
}
